module.exports = __webpack_public_path__ + "static/img/Icedrive.8b1e109.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/drive/logo/Icedrive.svg
// module id = QvJf
// module chunks = 2